const toggleAccordion = (event) => {
  const toggle = event.target
  const content = toggle.nextElementSibling
  if (!content) return

  event.preventDefault()

  if (toggle.classList.contains('active')) {
    toggle.classList.remove('active')
    content.style.maxHeight = null
    return;
  }

  [].forEach.call(document.querySelectorAll('.ecs_footer__map-title.active'), accordion => {
    accordion.classList.remove('active')
    accordion.nextElementSibling.style.maxHeight = null
  })

  content.style.maxHeight = `${content.scrollHeight}px`
  toggle.classList.toggle('active')
}

export default function () {
  if (window.innerWidth >= 992) {
    return
  }
  [].forEach.call(document.getElementsByClassName('ecs_footer__map-title'), accordion => {
    accordion.addEventListener('click', toggleAccordion)
  })
}



// WEBPACK FOOTER //
// ./src/partials/footer/footer.js